import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GoodsShipmentItemIDocuments } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface SaveGoodsItemDocumentsProps {
  declarationId: string;
  goodsItemId: string;
  documents: GoodsShipmentItemIDocuments;
}

const saveGoodsItemDocuments = async ({ declarationId, goodsItemId, documents }: SaveGoodsItemDocumentsProps) => {
  const result = await apiClient.declarationsDocuments.saveGoodsItemDocuments.mutation({
    params: { declarationId, goodsId: goodsItemId },
    body: { documents },
  });

  if (result.status !== 200) throw result.body;

  return result.body;
};

export const useSaveGoodsItemDocuments = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveGoodsItemDocuments,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declarationId] });
    },
    onError: (error) => {
      showErrorToast(error, 'Error saving goods item documents!');
    },
  });
};
